import { useEffect } from 'react';
import { useGetCurrentUserQuery } from '../features/apis/authApi';
import { useNavigate } from 'react-router-dom';
import type { User } from '../types/userTypes';

const useCurrentUser = (): User | undefined => {
  const { data, currentData, isLoading, isFetching, isError } =
    useGetCurrentUserQuery();
  const navigate = useNavigate();

  let user: User | undefined = undefined;

  if (data && !isLoading && !isFetching) {
    user = data.User;
  }

  useEffect(() => {
    if (isError && !data && !currentData) {
      navigate('/');
    }
  }, [isError, data, currentData, navigate]);

  return user;
};

export default useCurrentUser;
